module.exports = __webpack_public_path__ + "static/gallery-3-92366752166787ee430bda8d469d043c.jpg";